<template>
  <div>
  <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div v-if="urlValid === false">
      <h4 align="center">Welcome to Doodhvale, Please wait...</h4>
    </div>
    <div v-if="urlValid === true">
      <listOfProducts :products="getFilteredProducts"/>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import listOfProducts from '../../List/ListOfProducts'
import axios from 'axios'
// import Vue from 'vue'

export default {
  data () {
    return {
      getAllProducts: [],
      getFilteredProducts: [],
      urlInterface: [],
      apiDataObj: [],
      isFullPage: true,
      isLoading: true,
      urlValid: false,
      userId: 0
    }
  },
  created () {
    if (sessionStorage.getItem('promocodeName') !== null) {
      sessionStorage.removeItem('promocodeName')
      sessionStorage.removeItem('directLinkOfferedDiscount')
    }
    sessionStorage.removeItem('ringOnSelected')
    sessionStorage.removeItem('nice_to_have_req')
    sessionStorage.removeItem('subPaymentMode')
    sessionStorage.removeItem('subDate')
    sessionStorage.removeItem('scheduleText')
    sessionStorage.removeItem('isPostpaidDisabled')
    sessionStorage.removeItem('promoCodeVerified')
    sessionStorage.removeItem('promocodeText')
    sessionStorage.removeItem('prodQuantity')
    sessionStorage.removeItem('prodBaseQuantity')
    sessionStorage.removeItem('alternate')
    sessionStorage.removeItem('monQty')
    sessionStorage.removeItem('tueQty')
    sessionStorage.removeItem('wedQty')
    sessionStorage.removeItem('thuQty')
    sessionStorage.removeItem('friQty')
    sessionStorage.removeItem('satQty')
    sessionStorage.removeItem('sunQty')
    this.fetchData()
  },
  components: {
    listOfProducts
  },
  methods: {
    fetchData () {
      const params = new URLSearchParams()
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('productList?')
      params.append('url_str', splitUrl[1])
      axios({
        url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        this.urlInterface = {}
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          this.urlInterface.error_msg = response.data.msg
          this.urlValid = false
        } else {
          // this.urlValid = true
          this.urlInterface.action_name = response.data.action_name
          this.urlInterface.url_interface_id = response.data.url_interface_id
          this.invokeUrlAction()
        }
        this.isLoading = false
        // console.log(response)
      })
      .catch(e => {
        alert('not ok')
      })
    },

    invokeUrlAction () {
      const params = new URLSearchParams()
      params.append('url_interface_id', this.urlInterface.url_interface_id)
      params.append('action_name', this.urlInterface.action_name)
      axios({
        url: process.env.BASE_API + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        // console.log(response)
        this.apiDataObj = {}
        switch (this.urlInterface.action_name) {
          case 'product_list':
            this.userId = response.data.action_response.user_id
            this.getProductList()
            break
          default:
            break
        }
        this.isLoading = false
      })
      .catch(e => {
        alert('not ok')
      })
    },
    getProductList () {
      const params = new URLSearchParams()
      sessionStorage.setItem('userId', this.userId)
      // var userId = sessionStorage.getItem('userId')
      var userId = this.userId
      params.append('user_id', userId)
      params.append('cat_id', 2)
      params.append('device_type', 'web_view')
      axios({
        url: process.env.BASE_API + '/products/product-list',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        if (response.data.msg.trim().toUpperCase() === 'SUCCESS') {
          this.getAllProducts = response.data.product_list
          this.getFilteredProducts = this.getAllProducts.filter(function (p) {
            return p.subscription_type !== 'One Time'
          })
          this.urlValid = true
        }
      })
      .catch(e => {
        alert('Some Error Occured')
      })
    }
  }
}
</script>

<style scoped>
  .listOfProducts {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0;
  }

  .product {
    width: 300px;
    background-color: #fff;
    list-style: none;
    box-sizing: border-box;
    padding: 1em;
    margin: 1em 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 7px;
  }

  .product-name {
    font-size: 1.2em;
    font-weight: normal;
  }

  .product-price {
    width: 100%;
    align-self: flex-start;
    display: flex;
    justify-content: space-between;
    margin-bottom: .5em;
  }

</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/ProductList.vue